const CATEGORY_REDIRECTS = {
  'abrasive-sandblasting': ['abrasive-sand-blasting', 'abrasive-blasting'],
  'farm-machinery': ['agricultural-farm-machinery'],
  'car-air-conditioning': [
    'auto-air-conditioning',
    'automotive-air-conditioning',
  ],
  'commercial-air-conditioning': ['commercial-industrial-air-conditioning'],
  'air-conditioning-equipment-parts-supplies': [
    'air-conditioning-supplies-equipment',
    'air-conditioning-equipment-installation',
  ],
  'air-conditioning': ['air-conditioning-home', 'home-air-conditioning'],
  'auto-electricians': ['auto-electrical-services'],
  'auto-wreckers': ['car-wreckers'],
  'bathroom-equipment-accessories': ['bathroom-equipment'],
  'bathroom-renovations': ['bathroom-renovators'],
  'bike-shops': ['bikes-bicycle-accessories', 'bikes-accessories'],
  'bolts-nuts': ['nuts-bolts'],
  'book-shops': ['book-stores'],
  'bore-drilling': ['boring-drilling'],
  'building-pest-inspections': ['building-inspections'],
  builders: ['new-home-commercial-builders'],
  'building-home-renovations': ['building-alterations-renovations'],
  'trade-supplies': ['building-supplies'],
  'building-prefabricated-transportable': [
    'prefabricated-transportable-buildings',
  ],
  cafes: ['cafes-coffee-shops'],
  'canopies-boat-vehicle': ['boat-vehicle-canopies'],
  limousines: ['limousines-chauffeured-cars', 'limousines-hire-cars'],
  'container-sales-hire': ['cargo-freight-shipping-containers'],
  'carpet-cleaning': ['carpet-upholstery-cleaners'],
  'car-carriers': ['car-transport'],
  'electronic-pos-systems': [
    'cash-registers-pos-systems',
    'cash-registers-pos-equipment',
  ],
  'child-care-centres': ['child-care-centres-preschools'],
  'commercial-cleaners': ['commercial-industrial-cleaners'],
  cleaners: ['home-cleaners'],
  clocks: ['clock-sales-repairs'],
  'computer-sales-equipment': ['computers'],
  'computer-repairs': ['computer-repairs-installation'],
  'computer-network-it-consultants': [
    'it-network-system-consultants',
    'network-it-system-consultants',
  ],
  'concrete-additives-tools': ['concrete-additives-equipment'],
  'concrete-pre-mixed': ['premixed-concrete'],
  'lolly-shops': ['confectionery'],
  'building-construction-project-management': [
    'construction-project-management',
  ],
  'blind-curtain-cleaning': ['blind-repairs-curtain-cleaning'],
  'dog-grooming': ['dog-cat-clipping-washing-grooming'],
  doors: ['door-sales-fittings-repairs'],
  'employment-agencies-services': ['employment-services'],
  'excavator-earthmoving-hire': ['excavating-earthmovers'],
  'excavating-earthmoving-equipment': [
    'excavating-earthmoving-equipment-parts-repairs',
  ],
  fasteners: ['industrial-fasteners'],
  'fencing-contractors': ['fencing'],
  'fertilisers-supplies-spreading': ['fertilisers'],
  'fire-protection-services': ['fire-protection-consultants-equipment'],
  'first-aid-courses-supplies': ['first-aid-instruction-supplies'],
  'seafood-retailer-wholesalers': ['seafood'],
  'flooring-stores': ['laminate-vinyl-flooring', 'floor-coverings'],
  'convenience-stores': ['food-general-stores'],
  'shoe-shops-sales': ['shoe-sales-repairs'],
  'forklift-sales-hire-service': ['forklifts-sales-services'],
  '4x4-accessories': ['4x4-equipment-accessories', '4x4-equipment'],
  'funeral-directors': ['funerals'],
  'garage-builders': ['garage-builders-manufacturers'],
  'garage-doors': ['garage-doors-sales-repairs'],
  'gate-installation-repairs': ['gates-sales-installation-repairs'],
  'golf-lessons': ['golf-coaches'],
  'guttering-downpipes': ['guttering-spouting'],
  'hairdressing-supplies': ['hairdressers-supplies'],
  'hire-camping-leisure-equipment': ['camping-leisure-equipment-hire'],
  'hire-household-appliances-furniture': ['appliance-furniture-hire'],
  'hire-office-equipment-furniture': ['office-equipment-furniture-hire'],
  'home-improvements': ['home-improvements-repairs'],
  homeopaths: ['homoeopaths'],
  'house-relocation': ['house-removals'],
  hypnotherapy: ['hypnotherapists'],
  'ice-cream-frozen-yoghurt-shops': ['ice-cream-frozen-yoghurt'],
  'fly-screens': ['insect-screens'],
  'automotive-insurance': ['car-insurance'],
  isps: ['internet-service-providers'],
  'dating-agencies': ['dating-agencies-sites'],
  landscapers: ['landscapers-designers'],
  'laser-cutting-engraving': ['laser-equipment-cutting-engraving'],
  'lawn-mowers': ['lawnmower-sales-repairs'],
  'bottle-shops': ['bottleshops'],
  shutters: ['shutters-louvres'],
  'make-up-artists': ['make-up-artists-supplies'],
  'digital-marketing-agencies': ['marketing-agencies-consultants'],
  'martial-art-schools-suppliers': ['martial-arts-schools-supplies'],
  'mining-heavy-equipment-supplies-repairs': [
    'mining-heavy-equipment',
    'mining-quarrying-equipment-supplies',
  ],
  'mobile-phone-repairs': ['mobile-phones-repairs'],
  'modelling-agencies': ['model-agencies'],
  'auto-accessories': ['car-accessories'],
  'auto-upholstery': ['car-upholstery'],
  'car-wash-detailing': ['car-wash-cleaning-detailing'],
  auctions: ['car-auctions'],
  'car-performance-modifications': ['motor-car-conversions-modifications'],
  'car-dealers': ['new-cars'],
  'used-car-dealers': ['used-cars'],
  'motorcycle-dealers': ['motorcycle-sales', 'motorcycles-accessories'],
  'motor-oils': ['motor-oils-spirits'],
  'auto-parts': ['car-parts'],
  'novelty-message-services': ['answering-machine-messages'],
  'nursery-supplies': ['nurseries-supplies'],
  'nurses-nursing-services': ['aged-care-facilities-nursing-homes'],
  'aged-care-facilities': ['nursing-homes'],
  'patio-builders': ['patios'],
  pavers: ['paving-pavers'],
  'pest-control': ['pest-termite-control'],
  'photocopiers-printers': ['photocopiers-digital-printers'],
  photographers: ['commercial-industrial-photographers'],
  'photo-film-processing': ['film-processing'],
  'plasterers-plasterboard-contractors': ['plasterers-plasterboard-fixers'],
  'playground-equipment': ['playground-auditors-equipment'],
  'printing-services': ['printers-printing-services', 'printers'],
  refrigeration: ['commercial-industrial-refrigeration'],
  'fridge-repairs': ['fridge-repairs-seals'],
  'road-line-marking': ['line-marking'],
  'roofing-contractors': ['new-roofing', 'roof-construction'],
  'roof-restorations-repairs': [
    'roof-painting-repairs-restoration',
    'roof-repairs-restoration',
  ],
  sailmakers: ['marine-sails', 'yacht-sails'],
  'scaffolding-sales-hire': ['scaffolding'],
  'online-learning': ['correspondence-online-schools'],
  'security-systems': ['security-systems-consultants'],
  'shock-absorbers-suspension': ['shock-absorbers-springs-suspension'],
  'sign-shops': ['signs'],
  'solar-power-systems': ['solar-systems'],
  'steel-fabrication': ['steel-fabricators-manufacturers'],
  stockbrokers: ['stock-share-brokers'],
  'stone-masons': ['monumental-stone-masons'],
  'self-storage': ['storage'],
  'surf-shops': ['surf-wear-equipment-accessories'],
  'swimming-pool-builders': ['pool-builders-repairs', 'pool-builders'],
  'pool-cleaning-maintenance': ['pool-cleaners-renovations'],
  'takeaway-food': ['take-away-food'],
  'tax-accountants': ['tax-consultants'],
  'telephone-systems-sales-installation': [
    'telephone-system-sales-installation',
  ],
  'tv-antenna-installations': ['tv-antenna-sales-installation'],
  cinemas: ['cinemas-theatres'],
  'tipper-hire': ['tip-truck-hire'],
  'things-to-do': ['tourist-attractions-services'],
  'towing-services': ['towing'],
  arborists: ['arborist'],
  'general-valuers-appraisers-': ['general-valuers'],
  'video-production-services': ['digital-dvd-video-production'],
  wardrobes: ['wardrobes-sales-installation'],
  'waste-reduction-removal': ['waste-reduction-disposal'],
  'windscreen-repairs-replacements-': ['windscreen-repairs-replacements'],
  'abrasive-sand-blasting-equipment': ['abrasive-blasting-equipment'],
  'advertising-outdoor': ['outdoor-advertising-posters'],
  airlines: ['airlines-airline-agents'],
  'natural-therapies': ['natural-health-services'],
  'amusement-game-centres': ['game-centres'],
  'asbestos-removals': ['asbestos-removal-consultants'],
  'av-equipment-hire': ['audiovisual-equipment-hire'],
  'backpackers-hostel-accommodation': ['backpackers-accommodation'],
  'party-event-balloons': ['event-party-balloons'],
  'bbq-retailers': ['bbqs'],
  'pool-tables-accessories': ['billiard-tables-accessories'],
  'boat-jet-ski-licenses': ['boat-licence-testing'],
  'property-maintenance': ['building-maintenance-services'],
  'records-management-document-destruction': [
    'document-destruction-records-management',
  ],
  'motor-homes-rvs-campervans-sales': [
    'motor-homes-rvs-campervans-sales-hire',
    'campervans-motor-homes-sales-hire',
  ],
  'car-rental': ['car-4wd-minibus-rental'],
  'caravans-sales-parts': [
    'caravans-camper-trailers-sales-accessories',
    'caravans-camper-trailers-accessories',
  ],
  'caravan-repairs': ['caravans-camper-trailers-repairs'],
  'carpet-stores': ['carpet-retailers', 'carpets-flooring'],
  'carpet-vinyl-layers': ['carpet-vinyl-layers-repairs'],
  'clothing-custom-tailored': ['custom-tailored-clothing'],
  'computer-game-stores': ['game-stores'],
  'concrete-cutting': ['concrete-cutting-drilling-grinding-sawing'],
  curtains: ['curtain-sales-repairs', 'curtains-accessories'],
  'dance-wear': ['dance-wear-accessories'],
  'demolition-contractors': ['demolition'],
  djs: ['mobile-djs'],
  'domestic-assistance-services': ['domestic-help-services'],
  'electronic-equipment-sales-repairs': ['electronic-stores'],
  'elevating-work-platform-sales-hire': [
    'cherry-pickers-scissor-lifts-sales-hire',
  ],
  'custom-made-orthotics': ['orthopaedic-footwear-orthotics-custom-made'],
  'gas-fitters': ['gasfitters'],
  generators: ['generator-sales-hire-repairs'],
  'glass-repairs-replacements': [
    'glass-glaziers-repairs-replacements',
    'glass-glaziers',
  ],
  'hardware-stores': ['hardware-supplies'],
  'hire-medical-disabled-persons-equipment': [
    'disability-medical-equipment-hire',
  ],
  hydraulics: ['hydraulic-equipment-sales-repairs'],
  'private-investigators-detectives': ['investigation-services'],
  'kitchen-renovations-installations': [
    'kitchen-renovations-design',
    'kitchen-design-renovations',
  ],
  'lawn-mowing-services': ['lawnmowing-maintenance'],
  'music-stores-instruments': ['music-shops-musical-instruments'],
  'patent-solicitors': ['patent-attorneys'],
  'retirement-villages-communities-homes': ['retirement-communities-homes'],
  'rubbish-removal': ['rubbish-waste-removal'],
  'security-doors-screens': ['security-doors-windows'],
  'sports-stores': ['sporting-goods'],
  'superannuation-self-managed-funds': ['superannuation-consultants'],
  'water-tanks': ['tank-sales-installation'],
  'toilet-hygiene-services': ['toilet-washroom-services'],
  towbars: ['towbars-towing-equipment'],
  trailers: ['trailer-sales-repairs'],
  'training-centres': ['training-staff-development'],
  'car-transmissions': [
    'transmissions-differentials',
    'automatic-transmissions',
  ],
  'valve-equipment-repairs': ['valves-equipment-repairs'],
  galvanizing: ['galvanising-tinning'],
  'cabinet-maker-supplies': ['cabinet-makers-supplies'],
  'deck-builders': ['decking'],
  heating: [
    'heating-sales-repairs',
    'heating-appliances-systems-sales-repairs',
  ],
  'pipes-pipe-fittings': ['pipes-fittings'],
  'wharf-pontoon-jetty-construction': ['pontoons-jetties'],
  'auto-gearboxes': ['automotive-gearboxes'],
  'jet-ski-sales-servicing': ['jet-skis'],
  'property-development': ['commercial-real-estate-property-development'],
  'tools-equipment-trade-suppliers': ['tools-equipment-suppliers'],
  'carpet-vinyl-repairs': ['carpet-dyeing-vinyl-repairs', 'carpet-dyeing'],
  'industrial-instruments': ['general-instruments'],
  'mould-mildew-removal': ['mould-algae-removal'],
  'waxing-salons': ['waxing'],
  'crane-maintenance-repairs': ['crane-distributors-manufacturers-repairs'],
  'hire-baby-equipment': ['baby-equipment-hire'],
  'butcher-supplies': ['wholesale-butchers-supplies'],
  'beekeepers-beekeeping-supplies': ['beekeepers'],
  'smart-home': ['home-automation'],
  'petrol-pumps-sales-repairs': ['fuel-petrol-pumps-sales-repairs'],
  'voicemail-message-services': ['phone-messages-on-hold'],
  'timber-flooring-': ['bamboo-timber-flooring', 'timber-flooring'],
  'indoor-rock-climbing-venues': ['rock-climbing-venues-equipment'],
  'kids-party-venues-entertainers': ['childrens-parties-play-centres'],
  'epoxy-flooring': ['anti-slip-epoxy-floors'],
  'plastic-surgeons': ['cosmetic-surgeons', 'cosmetic-dental-surgery'],
  'sports-exercise-physiologists': ['exercise-physiologists'],
  'adult-shops': ['adult-shops-entertainment'],
  'chinese-restaurants': ['chinese-food'],
  'electrical-test-tag': ['electrical-testing-tagging'],
  'takeaway-fish-chips': ['fish-chips'],
  'human-resources': ['human-resources-development'],
  'pizza-places': ['pizza'],
  'skateboards-scooters': ['skateboards-accessories'],
  'skip-bin-hire': ['skip-bins-garden-bags'],
  'dental-veneers': ['veneers'],
  workwear: ['work-wear'],
  'jumping-castles': ['jumping-castles-sales-hire'],
  'mobility-scooters': ['disability-scooters', 'scooters-mobility-aids'],
  'farm-rural-contractors': ['farmers-rural-contractors'],
  'horse-care-supplies': ['horse-care'],
  'dent-repair': ['paintless-dent-removal'],
  'disability-care-services-support': ['disabled-care-services-support'],
  'kitchen-appliances-equipment': ['kitchen-appliances-kitchenware'],
  'underground-radars-locators': ['underground-service-locators'],
  'mining-heavy-machinery-repairs': ['mining-heavy-equipment-repairs'],
  'artificial-grass-turf-outdoor-surfaces': [
    'artifical-outdoor-surfaces',
    'synthetic-sporting-surfaces',
  ],
  'hire-portable-toilets': ['portable-toilet-hire', 'toilet-hire'],
  'renewable-energy': ['sustainable-energy-solutions'],
  'av-equipment-repairs': ['audiovisual-equipment-repairs'],
  'baby-car-seat-installations': ['child-car-seat-installations'],
  'hire-bikes-scooters-mopeds': ['bike-scooter-moped-hire'],
  'indian-restaurants': ['indian-food'],
  'thai-restaurants': ['thai-food'],
  'asian-restaurants': ['asian-food'],
  'japanese-restaurants': ['japanese-food'],
  'italian-restaurants': ['italian-food'],
  'greek-restaurants': ['greek-food'],
  'mexican-restaurants': ['mexican-food'],
  'vietnamese-restaurants': ['vietnamese-food'],
  'malaysian-restaurants': ['malaysian-food'],
  'aquatic-centres': ['swimming-centres'],
  'womens-clothing': ['ladies-fashion'],
  'adult-entertainment-strippers': ['adult-entertainment-escorts'],
  'bobcat-dingo-hire': ['bobcat-hire'],
  'concrete-decorative-resurfacing': ['decorative-resurfacing-concrete'],
  'family-lawyers': ['family-law'],
  'personal-injury-lawyers': ['personal-injury-law'],
  'boot-camps': ['bootcamps'],
  'after-hours-doctors': ['after-hours-home-doctors'],
  'cosmetic-skin-clinics': ['skin-treatment-products'],
  'cosmetic-services': ['fillers-cosmetic-injectables'],
  'eye-surgeons-clinics': ['eye-surgeons'],
};

module.exports = CATEGORY_REDIRECTS;
